(function () {
  var script = document.currentScript;
  var storageKey = script.dataset.storageKey;
  var selectorPrefix = script.dataset.selectorPrefix;
  var notLoggedInMessage = script.dataset.notLoggedInMessage;
  var extraHideSelector = script.dataset.extraHideSelector || '';
  var enableRetry = script.dataset.enableRetry === 'true';

  var TRIED_KEY = 'kp_' + storageKey + '_session_tried';
  var COUNT_KEY = 'kp_' + storageKey + '_bootstrap_attempts';
  var MAX_ATTEMPTS = 40;
  var RETRY_DELAY_MS = 3000;
  var RETRY_STATUS_TEXT = 'Signing you in — this can take a minute...';

  function sel(role) {
    return '[data-' + selectorPrefix + '-' + role + ']';
  }

  function getAttemptCount() {
    return parseInt(sessionStorage.getItem(COUNT_KEY) || '0', 10);
  }
  function clearAttemptState() {
    sessionStorage.removeItem(TRIED_KEY);
    sessionStorage.removeItem(COUNT_KEY);
  }

  function forceLoadingState(statusText) {
    setTimeout(function () {
      var loadingEl = document.querySelector(sel('loading'));
      var errorEl   = document.querySelector(sel('error'));
      var statusEl  = document.querySelector(sel('loading-status'));
      if (loadingEl) loadingEl.hidden = false;
      if (errorEl)   errorEl.hidden   = true;
      if (statusEl) {
        if (statusText) { statusEl.textContent = statusText; statusEl.hidden = false; }
        else { statusEl.hidden = true; }
      }
    }, 0);
  }

  // No Kwikpass token — reuse the header's own login button.
  function showLoggedOutPrompt() {
    setTimeout(function () {
      var loadingEl = document.querySelector(sel('loading'));
      var errorEl   = document.querySelector(sel('error'));
      var msgEl     = document.querySelector(sel('error-message'));
      var ctaEl     = document.querySelector(sel('login-cta'));
      var loginBtn  = document.querySelector(sel('login-button'));
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl)   errorEl.hidden   = false;
      if (msgEl)     msgEl.textContent = notLoggedInMessage;
      if (extraHideSelector) {
        var extraEl = document.querySelector(extraHideSelector);
        if (extraEl) extraEl.hidden = true;
      }
      if (ctaEl) ctaEl.hidden = false;
      if (loginBtn) {
        loginBtn.onclick = function () {
          var headerLoginBtn = document.getElementById('kp-login-button-header-logo');
          if (headerLoginBtn) {
            headerLoginBtn.click();
          } else if (typeof handleKpAndShopifyLogin === 'function') {
            handleKpAndShopifyLogin(window.location.pathname + window.location.search);
          }
        };
      }
    }, 0);
  }

  // SDK never loaded — fall back to the normal error state.
  function revertToNaturalErrorState() {
    setTimeout(function () {
      var loadingEl = document.querySelector(sel('loading'));
      var errorEl   = document.querySelector(sel('error'));
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl)   errorEl.hidden   = false;
    }, 0);
  }

  function ready() {
    return typeof handleKpAndShopifyLogin === 'function'
      && typeof getValueFromCookiesOrLocalStorage === 'function'
      && typeof XGokwikCoreToken === 'function'
      && !!window.merchantInfo;
  }

  function startBootstrapAttempt() {
    forceLoadingState();
    var done = false;
    var waited = 0;
    function attempt() {
      if (done || !ready()) return;
      var token;
      try {
        token = getValueFromCookiesOrLocalStorage(XGokwikCoreToken(window.merchantInfo.environment));
      } catch (e) {
        return;
      }
      done = true;
      clearInterval(poll);
      if (token) {
        if (enableRetry) sessionStorage.setItem(COUNT_KEY, String(getAttemptCount() + 1));
        sessionStorage.setItem(TRIED_KEY, '1');
        handleKpAndShopifyLogin(window.location.pathname + window.location.search);
      } else {
        clearAttemptState();
        showLoggedOutPrompt();
      }
    }
    var poll = setInterval(function () {
      waited += 300;
      attempt();
      if (done || waited >= 8000) {
        clearInterval(poll);
        if (!done) {
          clearAttemptState();
          revertToNaturalErrorState();
        }
      }
    }, 300);
    attempt();
  }

  var isReturnTrip = !!sessionStorage.getItem(TRIED_KEY);

  if (enableRetry) {
    // Addresses page: retry across return trips (Kwikpass sign-in redirects
    // back here) up to MAX_ATTEMPTS, spaced RETRY_DELAY_MS apart.
    if (isReturnTrip) {
      sessionStorage.removeItem(TRIED_KEY);
      if (getAttemptCount() >= MAX_ATTEMPTS) {
        clearAttemptState();
        return;
      }
      forceLoadingState(RETRY_STATUS_TEXT);
      setTimeout(startBootstrapAttempt, RETRY_DELAY_MS);
    } else {
      startBootstrapAttempt();
    }
  } else {
    // Orders page: bootstrap once per visit — no retry on return trip.
    sessionStorage.removeItem(TRIED_KEY);
    if (!isReturnTrip) {
      startBootstrapAttempt();
    }
  }
})();
